import React from 'react';
import { View } from 'react-native';
import { Feather, Ionicons } from '@expo/vector-icons';

import { ListRow, StatusBadge } from '../../design/components';
import { useTheme } from '../../theme';
import { useThemedStyles } from '../../hooks/useThemedStyles';

// One hub link (My account, Warehouse): icon tile, label, description, optional count of items needing action.
const NavigationHubMenuItem = ({ label, description, icon, badge, onPress }) => {
	const styles = useThemedStyles(createStyles);
	const { theme: { ui: { colors } } } = useTheme();

	return (
		<ListRow
			title={label}
			subtitle={description}
			// The badge is drawn in `right`; `value` (not shown next to `right`) puts the count in the row's spoken label.
			value={badge ? `${badge} ${badge === 1 ? 'needs' : 'need'} action` : undefined}
			onPress={onPress}
			left={(
				<View style={styles.iconTile}>
					<Ionicons name={icon} size={22} color={colors.accent} />
				</View>
			)}
			// Without a badge ListRow draws the same chevron itself.
			right={badge ? (
				<View style={styles.rowEnd}>
					<StatusBadge label={String(badge)} tone="danger" size="small" />
					<Feather name="chevron-right" size={22} color={colors.iconMuted} />
				</View>
			) : undefined}
		/>
	);
};

const createStyles = ({ ui: { colors, radius, space } }) => ({
	iconTile: {
		width: 40,
		height: 40,
		borderRadius: radius.card,
		backgroundColor: colors.chip,
		alignItems: 'center',
		justifyContent: 'center',
	},
	rowEnd: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.sm,
	},
});

export default NavigationHubMenuItem;
